import { ConfirmDialog } from "@/components/ui/dialog";

interface ConfirmationModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  message: string;
  /** The verb on the button. It should name the act, never say "OK". */
  confirmLabel?: string;
}

/**
 * The delete confirmation, kept under its original name so the four screens
 * that call it did not all have to change at once. It is the shared
 * `ConfirmDialog` underneath, which means one modal shape in the whole app.
 */
export function ConfirmationModal({
  isOpen,
  onClose,
  onConfirm,
  title,
  message,
  confirmLabel = "Delete",
}: ConfirmationModalProps) {
  return (
    <ConfirmDialog
      open={isOpen}
      onClose={onClose}
      onConfirm={onConfirm}
      title={title}
      message={message}
      confirmLabel={confirmLabel}
    />
  );
}
